module.exports = __webpack_public_path__ + "static/media/assist-enterprise.084bd187.png";